import { createFileRoute } from "@tanstack/react-router";
import { Hero } from "@/components/site/Hero";
import { FoundersWord } from "@/components/site/FoundersWord";
import { LanguagePills } from "@/components/site/LanguagePills";
import { StoryFeed } from "@/components/site/StoryFeed";
import { storiesListQuery, categoriesAllQuery } from "@/lib/stories";
import type { Lang } from "@/lib/i18n";

export const Route = createFileRoute("/$lang/")({
  head: ({ params }) => ({
    meta: [
      { title: "MadCaptains — Stories the logbook never recorded" },
      {
        name: "description",
        content:
          "An anonymous, multilingual archive of harassment at sea — testimony from the merchant fleet, kept honest and pre-moderated.",
      },
      { property: "og:title", content: "MadCaptains.net" },
      {
        property: "og:description",
        content: "What happens at sea should not stay at sea — when it breaks a human being.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: `/${params.lang}` },
    ],
    links: [{ rel: "canonical", href: `/${params.lang}` }],
  }),
  loader: ({ context, params }) =>
    Promise.all([
      context.queryClient.ensureQueryData(storiesListQuery(params.lang as Lang)),
      context.queryClient.ensureQueryData(categoriesAllQuery()),
    ]),
  component: Home,
  errorComponent: HomeError,
  notFoundComponent: () => null,
});

function Home() {
  const { lang } = Route.useParams();
  return (
    <>
      <Hero lang={lang as Lang} />
      <LanguagePills lang={lang as Lang} />
      <StoryFeed lang={lang as Lang} />
      <FoundersWord />
    </>
  );
}

function HomeError({ error }: { error: Error }) {
  return (
    <div className="mx-auto max-w-5xl px-5 py-16 text-center">
      <p className="text-sm text-muted-foreground">Could not load stories: {error.message}</p>
    </div>
  );
}